import React, { useContext } from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import { useDeviationViewContext } from '../../../../Context';
import { SecondaryActionBarContext } from '../../../ActionBarContext';
import ActionBarStrip from '../../../_partials/ActionBarStrip';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import SubscribersOnly from '../../../_partials/SubscribersOnly';
import { useDeviationAttributes } from '../../../../DeviationViews/hooks/useDeviationAttributes';
import { isTextualDeviation } from '../../../../DeviationViews/_helpers';
import DeviationFlags from '../../../buttons/DeviationFlags';
import CommentButton from '../../../buttons/CommentButton';
import FavouriteButton from '../../../buttons/FavouriteButtonWithPopover';
import AddToGroupButton from '../../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../../buttons/MoreButton';
import EditButton from '../../../buttons/EditButton';
import EditBackgroundButton from '../../../buttons/EditBackgroundButton';
import DeleteButton from '../../../buttons/DeleteButton';
import ExpandButton from '../../../buttons/ExpandButton';
import FreeDownloadButton from '../../../buttons/DownloadButton/FreeDownloadButton';
import PremiumDownloadButton from '../../../buttons/DownloadButton/PremiumDownloadButton';
import AwardBadgeButton from '../../../buttons/AwardBadgeButton';
import DownloadWithCommentPrompt from '../../../buttons/DownloadButton/DownloadButtonWithCommentPrompt';
import SellYourArtLink from '../../../buttons/SellYourArtLink';
import FluidMargin from '../FluidMargin';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import AdoptSeller from '../../../buttons/AdoptableSeller';
import AdoptBuyer from '../../../buttons/AdoptableBuyer';
import { useIsAddToGroupInMoreMenu } from '../../../buttons/MoreButton/hooks';
import AddToPrivateCollectionButton from '../../../buttons/AddToPrivateCollectionButtonWithPopover';
import { getAllowOffers, getHasBuyItNow } from '../../../../utils/adoptables';
import desktopActionBarStyles from '../DesktopActionBar.scss';
export const PrimaryDesktopActionBar = ({ deviation, isOwner, className, expandAndFocusCommentPanel })=>{
    var _deviation_adoptable, _deviation_extended, _deviation_extended_adoptable, _deviation_extended1;
    const { isLoggedIn } = useContext(SessionContext);
    const { isTheater } = useDeviationViewContext();
    const { setTopActionBarRef } = useContext(SecondaryActionBarContext);
    const { hasFlag, hasMoreActions, isCommentable, isDownloadable, isEditable, isDeletable, isFavouritable, isGroupSubmittable, isPurchasable, isReportable, isBackgroundEditable, isCoreBadgeAwardable } = useDeviationAttributes(deviation, isOwner);
    const { tier } = useSubscriptionTier(deviation);
    const isTextual = isTextualDeviation(deviation);
    const isAddToGroupInMoreMenu = useIsAddToGroupInMoreMenu(deviation);
    const isPrivateCollections = useFlag('private_collections');
    const isAnAdoptable = deviation.isAdoptable;
    const hasSubsBadge = !hasFlag && !!tier;
    const badgeClassnames = classnames(desktopActionBarStyles['badge'], hasSubsBadge && desktopActionBarStyles['subs-badge']);
    var _deviation_adoptable_status;
    const adoptableStatus = (_deviation_adoptable_status = (_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : _deviation_adoptable.status) !== null && _deviation_adoptable_status !== void 0 ? _deviation_adoptable_status : 'not_onsale';
    const showSellYourArt = !!((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.canUserSell) && adoptableStatus === 'not_onsale';
    const canBuyAdoptable = ((_deviation_extended_adoptable = (_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : _deviation_extended1.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : _deviation_extended_adoptable.canAdopt) && !isOwner;
    const adoptableHasOffers = getAllowOffers(deviation);
    const adoptableHasBuyItNow = getHasBuyItNow(deviation);
    const adoptableRequiresSpace = adoptableHasOffers && adoptableHasBuyItNow && canBuyAdoptable;
    // If this is an adoptable and we're the seller, we don't show the comment button, likely to save space
    const showCommentButton = (!isAnAdoptable || !isOwner) && isCommentable;
    return /*#__PURE__*/ React.createElement(ActionBarStrip, {
        ref: setTopActionBarRef,
        className: classnames(desktopActionBarStyles['root'], isTheater ? desktopActionBarStyles['theater'] : desktopActionBarStyles['normal-view'], isOwner && desktopActionBarStyles['owner'], isTextual && desktopActionBarStyles['literature'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: badgeClassnames
    }, hasFlag && /*#__PURE__*/ React.createElement(DeviationFlags, {
        className: desktopActionBarStyles['flag'],
        deviation: deviation,
        disableLabel: isTextual
    }), hasSubsBadge && /*#__PURE__*/ React.createElement(SubscribersOnly, {
        deviation: deviation,
        className: desktopActionBarStyles['subscribers-only'],
        textClassName: desktopActionBarStyles['subscribers-only-text']
    })), /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 1
    }), /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-middle']
    }, /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, isFavouritable && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'], desktopActionBarStyles['icon-with-label'])
    }, /*#__PURE__*/ React.createElement(FavouriteButton, {
        deviation: deviation,
        actionBarType: "primary"
    })), showCommentButton && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'], desktopActionBarStyles['icon-with-label'], isAnAdoptable && desktopActionBarStyles['overflow-responsive'])
    }, /*#__PURE__*/ React.createElement(CommentButton, {
        deviation: deviation,
        isOwner: isOwner,
        actionBarType: "primary"
    }))), !isOwner && /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 4
    }), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, !adoptableRequiresSpace && isPrivateCollections && !isOwner && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'], isAnAdoptable && desktopActionBarStyles['overflow-responsive'])
    }, /*#__PURE__*/ React.createElement(AddToPrivateCollectionButton, {
        deviation: deviation,
        actionBarType: "primary"
    })), isGroupSubmittable && !isAddToGroupInMoreMenu && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(AddToGroupButton, {
        deviation: deviation,
        actionBarType: "primary"
    })), !adoptableRequiresSpace && isCoreBadgeAwardable && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'], isAnAdoptable && desktopActionBarStyles['overflow-responsive'])
    }, /*#__PURE__*/ React.createElement(AwardBadgeButton, {
        deviation: deviation
    })), !adoptableRequiresSpace && isPurchasable && /*#__PURE__*/ React.createElement(DownloadWithCommentPrompt, {
        className: classnames(desktopActionBarStyles['icon'], isAnAdoptable && desktopActionBarStyles['overflow-responsive']),
        buttonComponent: PremiumDownloadButton,
        deviation: deviation
    }), !adoptableRequiresSpace && isDownloadable && /*#__PURE__*/ React.createElement(DownloadWithCommentPrompt, {
        className: classnames(desktopActionBarStyles['icon'], isAnAdoptable && desktopActionBarStyles['overflow-responsive']),
        buttonComponent: FreeDownloadButton,
        deviation: deviation
    }), isAnAdoptable && isOwner && /*#__PURE__*/ React.createElement(AdoptSeller, {
        className: desktopActionBarStyles['icon'],
        deviation: deviation
    }), canBuyAdoptable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(AdoptBuyer, {
        deviation: deviation
    }))), (isReportable || isEditable || isDeletable) && /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 2
    }), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, showSellYourArt && /*#__PURE__*/ React.createElement(SellYourArtLink, {
        className: desktopActionBarStyles['icon'],
        deviation: deviation
    }), hasMoreActions && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation
    })), isBackgroundEditable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(EditBackgroundButton, {
        deviation: deviation
    })), isDeletable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(DeleteButton, {
        deviation: deviation
    })), isEditable && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    })))), /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 3
    }), /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-right']
    }, isLoggedIn && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(ExpandButton, {
        deviation: deviation
    })))));
};
PrimaryDesktopActionBar.displayName = 'PrimaryDesktopActionBar';
export default PrimaryDesktopActionBar;
